import { LearningPathBannerProps } from '@components/learningPath/learningPathBanner/learningPathBanner';

const convertLearningPathToBanner = (learningPath: any): LearningPathBannerProps => {
    return {
        duration: learningPath.duration,
        description: learningPath.description,
        uuid: learningPath.uuid,
        status: learningPath.progress?.status || learningPath.status,
        name: learningPath.name
    };
};

export default convertLearningPathToBanner;
